import { useEffect } from 'react';
import useWebsocket from './useWebsocket';
import { useGetInitialData } from './initialHooks';

const useNetwork = (): void => {
    const { initialFetch } = useGetInitialData(false);
    const ws = useWebsocket();
    const onGettingOnline = async () => {
        await initialFetch();
    };

    const onGettingOffline = () => {
        ws.networkDisconnect();
    };

    useEffect(() => {
        window.addEventListener('online', onGettingOnline);
        window.addEventListener('offline', onGettingOffline);
        return () => {
            window.removeEventListener('online', onGettingOnline);
            window.removeEventListener('offline', onGettingOffline);
        };
    }, []);
};

export default useNetwork;
